import moment from "moment";

type Props = {
  value?: string | null;
};

const hasClockTime = (value: string) => /(?:T|\s)\d{1,2}:\d{2}/.test(value);

const ListDateTime = ({ value }: Props) => {
  if (!value) {
    return <span>-</span>;
  }

  const parsed = moment(value);
  if (!parsed.isValid()) {
    return <span>{value}</span>;
  }

  return (
    <div>
      <div className="font-normal text-slate-800">
        {parsed.format("DD MMM YYYY")}
      </div>
      {hasClockTime(String(value)) ? (
        <div className="font-normal text-slate-800">
          {parsed.format("hh:mm A")}
        </div>
      ) : null}
    </div>
  );
};

export default ListDateTime;
